import { render } from "./MailsGroup.vue?vue&type=template&id=15fd1488"
import script from "./MailsGroup.vue?vue&type=script&lang=js"
export * from "./MailsGroup.vue?vue&type=script&lang=js"

import "./MailsGroup.vue?vue&type=style&index=0&id=15fd1488&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__